import {Users} from 'lucide-react';

export const RoomGlyph = () => (
    <span aria-hidden="true" className="inline-flex h-16 w-16 items-center justify-center rounded-[20px] bg-[var(--phq-call-brand-tint)] text-[var(--phq-call-brand-ink)]">
        <Users size={28}/>
    </span>
);
